export enum EMailAttachToEntityType {
  NONE = 'NONE',
  TICKET = 'TICKET',
}
